<ng-container *ngIf="!showExport">
  <payarc-page-header [title]="'Bank Account Change History'"></payarc-page-header>

  <payarc-filter-bar class="crh-filter-row">
    <payarc-search placeholder="Search" [value]="searchText || ''" (valueChange)="onSearch($event)"></payarc-search>
    <div class="pa-row pa-gap-8">
      <span id="crhDateRangeLabel">Date range</span>
      <input type="text" class="pa-input" aria-labelledby="crhDateRangeLabel" aria-label="From date"
             [matDatepicker]="dp" [max]="today" placeholder="From" (click)="dp.open()" [(ngModel)]="from_date" (dateChange)="checkdate()" readonly />
      <mat-datepicker #dp (closed)="datereport()"></mat-datepicker>
      <input type="text" class="pa-input" aria-labelledby="crhDateRangeLabel" aria-label="To date"
             [matDatepicker]="dp1" [(ngModel)]="to_date" placeholder="To" [max]="today" (click)="dp1.open()" (dateChange)="checkdate2()" readonly />
      <mat-datepicker #dp1 (closed)="datereport()"></mat-datepicker>
      <payarc-date-clear [visible]="from_date || to_date" (cleared)="clearDates()"></payarc-date-clear>
    </div>
    <button actions type="button" payarcButton="primary" (click)="openexcel()">Export</button>
  </payarc-filter-bar>

  <payarc-section-card [flush]="true">
    <div class="pa-table-wrap">
      <payarc-table>
        <thead>
          <tr>
            <th>Requested by</th>
            <th [attr.aria-sort]="ariaSort(sortDirection('requested_at'))">
              <button type="button" class="pa-th-sort" (click)="setSorting('requested_at')">Requested date <payarc-sort-icon [direction]="sortDirection('requested_at')"></payarc-sort-icon></button>
            </th>
            <th>Used for</th>
            <th>Status</th>
            <th>New RN</th>
            <th>New acct</th>
            <th>Old RN</th>
            <th>Old acct</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="loadFlag">
            <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
              <td *ngFor="let c of [1,2,3,4,5,6,7,8,9]"><span class="pa-skeleton-bar"></span></td>
            </tr>
          </ng-container>

          <tr *ngIf="!loadFlag && errorMsg">
            <td class="pa-table__state-cell" colspan="9">
              <payarc-empty-state title="No change requests found" [message]="errorMsg"></payarc-empty-state>
            </td>
          </tr>

          <ng-container *ngIf="!loadFlag && !errorMsg && changeRequestList.data.length > 0">
            <!-- row click / Enter opens the change request panel (desktop and mobile); View keeps
                 opening the full request dialog directly -->
            <tr class="crh-row" *ngFor="let c_request of changeRequestList.data" tabindex="0" [attr.aria-label]="historyRowAriaLabel(c_request)"
                (click)="openHistoryDetail(c_request)"
                (keydown.enter)="$event.target === $event.currentTarget && openHistoryDetail(c_request)">
              <td class="strong" [innerHTML]="highlight(c_request.requested_by_user_name)"></td>
              <td class="muted" [title]="c_request.requested_at | dateonly:'MM/DD/yyyy'">{{ c_request.requested_at | dateonly:'MM/DD/yyyy' }}</td>
              <td class="muted" [innerHTML]="highlight(c_request.used_for)"></td>
              <td><payarc-status-badge [status]="c_request.history_status"></payarc-status-badge></td>
              <td class="muted" [innerHTML]="highlight(c_request.routing_number)"></td>
              <td class="muted" [innerHTML]="highlight(c_request.bank_account_number)"></td>
              <td class="muted" [innerHTML]="highlight(c_request.old_routing_number)"></td>
              <td class="muted" [innerHTML]="highlight(c_request.old_bank_account_number)"></td>
              <td>
                <button type="button" payarcButton="ghost" (click)="$event.stopPropagation(); reveal(c_request)">View</button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </payarc-table>
    </div>

    <div class="crh-pager-row" *ngIf="!errorMsg && changeRequestList?.data?.length > 0">
      <label class="crh-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="limitChange()">
          <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="pagerPages"
        [currentPage]="currentPage"
        [disablePrev]="currentPage <= 1"
        [disableNext]="currentPage >= totalPages"
        (prev)="pagerPrev()"
        (next)="pagerNext()"
        (pageSelect)="pagerSelect($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>
</ng-container>

<div *ngIf="showExport">
  <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [filterUrl]="filterPostFix" [searchData]="searchText"></app-export-excel>
</div>
